import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Button, Form, Row, Col, Card, Container } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { candidateActions } from "../../actions/candidateActions";
import api from "../../api/candidate.resource";
import { defaultToastOptions } from "../../constants/constants";

const AddUser = ({
  genders,
  getGendersList,
  history,
  location: { userData = {} }
}) => {
  const initialUserDetails = {
    userName: userData.userName || "",
    roleId: userData.roleId || "",
    firstName: userData.firstName || "",
    middleName: userData.middleName || "",
    lastName: userData.lastName || "",
    contactNumber: userData.contactNumber || "",
    status: 1,
    gender: userData.gender || "",
    emailId: userData.emailId || ""
  };

  const [userDetails, setUserDetails] = useState(initialUserDetails);
  useEffect(() => {
    getGendersList();
  }, []);

  const handleOnChangeInput = e => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === "checkbox" ? Number(checked) : value;
    setUserDetails(prevState => ({ ...prevState, [name]: updatedValue }));
  };

  const handleOnChangeUseEmailAsUserName = e => {
    const isChecked = e.target.checked;
    setUserDetails(prevState => ({
      ...prevState,
      userName: isChecked ? prevState.emailId : ""
    }));
  };

  const handleOnSubmitCreateUser = async () => {
    try {
      toast.configure();

      const res = await api.createNewUser(userDetails);
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          toast.success(`Successfully Created User`, defaultToastOptions);
          setTimeout(() => history.push("/CandidateList"), 3000);
        }
      }
    } catch (e) {
      toast.error(`Error while Creating User`, defaultToastOptions);
    }
  };

  return (
    <Fragment>
      <Container className="lg-12">
        <div className="Container mt-4 ml-3 ">
          <Card>
            <Card.Header className="accordian-header" align="center">
              ADD USER
            </Card.Header>
            <Card.Body>
              <div className="Container mt-3">
                <div className="Container col-sm-6 w-100 mx-auto">
                  <Form>
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="text-right">
                        First Name
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          value={userDetails.firstName}
                          onChange={handleOnChangeInput}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="text-right">
                        Middle Name
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="middleName"
                          placeholder="Middle Name"
                          value={userDetails.middleName}
                          onChange={handleOnChangeInput}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="text-right">
                        Last Name
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          value={userDetails.lastName}
                          onChange={handleOnChangeInput}
                        />
                      </Col>
                    </Form.Group>

                    <fieldset>
                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label
                          as="legend"
                          column
                          sm={4}
                          className="text-right"
                        >
                          Gender
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            size="sm"
                            as="select"
                            name="gender"
                            value={userDetails.gender}
                            onChange={handleOnChangeInput}
                          >
                            <option value="">Choose...</option>
                            {genders.length &&
                              genders.map(gender => (
                                <option value={gender.id}>
                                  {gender.genderType}
                                </option>
                              ))}
                          </Form.Control>
                        </Col>
                      </Form.Group>
                    </fieldset>
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="text-right">
                        Role
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          size="sm"
                          as="select"
                          className="my-1 mr-sm-2"
                          custom
                          name="roleId"
                          value={userDetails.roleId}
                          onChange={handleOnChangeInput}
                        >
                          <option value="">Choose...</option>
                          <option value="3">Candidate</option>
                          <option value="2">HR</option>
                        </Form.Control>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="text-right">
                        Mobile
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="contactNumber"
                          placeholder="Mobile"
                          value={userDetails.contactNumber}
                          onChange={handleOnChangeInput}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="text-right">
                        Email
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="emailId"
                          placeholder="Email"
                          value={userDetails.emailId}
                          onChange={handleOnChangeInput}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="text-right">
                        UserName
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="userName"
                          placeholder="UserName"
                          value={userDetails.userName}
                          onChange={handleOnChangeInput}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group
                      as={Row}
                      controlId="formHorizontalCheck"
                      className="w-100 pt-3 ml-0 text-left"
                    >
                      <Col sm={{ span: 6, offset: 2 }}>
                        <Form.Check
                          label="Use Email as UserName"
                          disabled={!userDetails.emailId}
                          onChange={handleOnChangeUseEmailAsUserName}
                        />
                      </Col>

                      <Col sm={{ span: 4, offset: 0 }}>
                        <Form.Check
                          label="Invite User"
                          name="inviteUser"
                          value={userDetails.inviteUser}
                          onChange={handleOnChangeInput}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group
                      as={Row}
                      className="w-100 pt-3 ml-0 text-center"
                    >
                      <Col sm={{ span: 10, offset: 2 }}>
                        <Button onClick={handleOnSubmitCreateUser}>
                          CREATE USER
                        </Button>
                      </Col>
                    </Form.Group>
                  </Form>
                </div>
              </div>
            </Card.Body>{" "}
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};
const mapStateToProps = ({ candidateDetails }) => ({
  genders: candidateDetails.genders || []
});
const mapDispatchToProps = {
  getGendersList: candidateActions.getGendersList
};
export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
